import React, { useEffect, useState } from "react";

import { Delete } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';

import { TableRow, TableCell, IconButton, Box, Button, DialogActions, DialogContentText, Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";

const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

function formatearFecha(fecha) {
  // Si ya parece estar formateada, la devolvemos como está
  if (typeof fecha === 'string' && fecha.includes('de') && fecha.includes(':')) {
    return fecha;
  }

  const date = new Date(fecha);
  return date.toLocaleString('es-CO', {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

const RowTableCaja = ({data, handleDelete, handleEditCaja, areUserAdmin }) => {
  const [openAlertDelete, setOpenAlertDelete] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {    
    if (data.empleado?.rol === "Administrador") {
      setShow(false); // Oculta la fila si el rol es Administrador
    }
  }, [data]);

  return (
    <React.Fragment>
      { areUserAdmin && <Dialog
        open={openAlertDelete}
        keepMounted
        onClose={() => {setOpenAlertDelete(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Espera un Segundo!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Estás apunto de eliminar esta Caja del Registro de Cajas de este parqueadero
            ¿Estás seguro de que quieras hacer esto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenAlertDelete(false)}} color='error' variant="outlined">No</Button>
          <Button onClick={() => {setOpenAlertDelete(false); handleDelete(data); }} color='primary' variant="contained">¡Sí!</Button>
        </DialogActions>
      </Dialog>}

      {show && <TableRow sx={{ '& > *': { backgroundColor: data.estado ? green[700] : red[700] } }}>
        <TableCell component="th" scope="row" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {data.id} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {data.nombre} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {formatNumber(data.dinero_base)} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {formatNumber(data.total_ingresos)} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {formatNumber(data.total_egresos)} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {data.saldo_final ? formatNumber(data.saldo_final) : 'No ha terminado'} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {formatearFecha(data.fecha_hora_inicio)} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', color: 'black'}}> {data.fecha_hora_fin ? formatearFecha(data.fecha_hora_fin) : 'No ha terminado'} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', borderRight: areUserAdmin ? null : '2px solid #ddd', color: 'black'}}> {data.estado ? 'Activo' : 'Terminado'} </TableCell>
        {areUserAdmin && <TableCell sx={{ borderLeft: '2px solid #ddd', borderRight: '2px solid #ddd', borderBottom: '2px solid #ddd'}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconButton
                size="large"
                onClick={() => {handleEditCaja(data)}}
                sx={{ color: '#grey', padding: 0, border: '2px grey' }}
              >
                <VisibilityIcon sx={{ fontSize: '33px' }}/>
              </IconButton>
              <IconButton
                size="large"
                onClick={() => { setOpenAlertDelete(true) }} // Se ejecuta la eliminación
                sx={{ color: '#grey', padding: 0, border: '2px grey' }}
              >
                <Delete sx={{ fontSize: '33px' }}/>
              </IconButton>
          </Box>
        </TableCell>}
      </TableRow>}

    </React.Fragment>
  );
}

export default RowTableCaja;
